import { Button, Form } from "react-bootstrap";
import { User } from "../../interfaces/User";
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface UserDeleteProps {
    user: User;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function UserDelete(props: UserDeleteProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/user/' + props.user._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.user._id);
            })
            .catch(error => {
                navigate('/');
            });
    }

    return(
        <Overlay title={t("Delete user")} onClose={handleClose} className="admin-delete-user-container">
            <Form onSubmit={ handleSubmit }>
                <Form.Text id="deleteConfirmationMessage">
                    { parse(t("You are about to delete user with email") + ' ' + '<strong>' + props.user.email + '</strong>. ' +
                        t("All user data and tasks will be deleted. This action cannot be undone.") + ' ' +
                        t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
                <div className="actions">
                    <Button variant="primary" type="submit">{ t("Yes") }</Button>
                    <Button variant="secondary" onClick={ handleClose }>{ t("No") }</Button>
                </div>
            </Form>
        </Overlay>
    );
}